var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"basefooter"},[_c('source-footer',{attrs:{"lang":_vm.toggleLang,"source":_vm.source,"summary":_vm.summary,"summaryContent":_vm.summaryContent,"faq":_vm.faq}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }